<template>
  <div>
    <el-row class="cs-serviceInfoList-item" v-for="(item, index) in dataIn.serviceList" :key="index">
      <el-col class="cs-serviceInfoList-item-left" :span="6">
        <span class="cs-title">{{item.serviceName}}</span>
        <span class="cs-title cs-serviceTotalPrice">{{item.totalPrice | toCurrency(dataIn.currency)}}</span>
        <span class="cs-color-frenchgrey">折扣优惠 -{{item.discountAmount | toCurrency(dataIn.currency)}}</span>
        <span class="cs-color-frenchgrey">现金减 -{{item.cashDecreasedAmount | toCurrency(dataIn.currency)}}</span>
      </el-col>
      <el-col :span="12">
        <serviceItemList :dataIn="{currency: dataIn.currency, itemList: item.itemList}"/>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-serviceInfoList-item{
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ced3d9;

  .cs-serviceInfoList-item-left{
    span{
      display: block;
    }
    .cs-title{
      font-weight: bold;
    }

    .cs-serviceTotalPrice{
      margin-bottom: 10px;
    }

    .cs-color-frenchgrey{
      line-height: 25px;
    }
  }
}
</style>

<script>
import serviceItemList from "./serviceItemList";
export default {
  props: {
    dataIn:{
      currency: Number,
      serviceList:Array
    }
  },
  data() {
    return {

    };
  },
  components: {
    serviceItemList
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {

    },
  },
  watch: {
    dataIn: function(){
      this.init();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/serviceInfoList.vue